import { doc, query, where, limit, getDoc, getDocs, addDoc, updateDoc } from "firebase/firestore";
import { auth, app, database, refList } from "./configFirebase";
import { getFunctions, httpsCallable } from "firebase/functions";

export const READ = (reference) => {
   return new Promise((resolve, reject) => {
    let array = []
    getDocs(refList[`${reference}REF`])
      .then((snapshot) => {
        snapshot.docs.forEach((element) => { array.push({...element.data(), firestoreid: element.id}) })
        resolve(array) 
      })
      .catch(err => { reject(err.message)})
  })
};

export const CLOUDREAD = async (reference) => {
   const functions = getFunctions(app, "us-central1");
    const readCollection = httpsCallable(functions, "readCollection");
    const result = await readCollection({ reference });
    return result.data;
};

export const FIND = (reference, filterKey, filterValue) => {
  return new Promise((resolve, reject) => {
    const q = query(refList[`${reference}REF`], where(filterKey, "==", filterValue), limit(1));
    getDocs(q)
      .then((snapshot) => {
        if (snapshot.empty) {
          resolve(null);
        } else {
          const doc = snapshot.docs[0];
          resolve({...doc.data(), firestoreid: doc.id});
        }
      })
      .catch(err => reject(err.message));
  });
};

export const CLOUDFIND = async (list, key, value) => {
    const functions = getFunctions(app, "us-central1");
    const findOne = httpsCallable(functions, "findOne");
    const result = await findOne({ list, key, value });
    return result.data.data
};

export const FILTER = async (reference, filterKey, filterValue) => {
    const q = query(refList[`${reference}REF`], where(filterKey, "==", filterValue));
    try {
        const snapshot = await getDocs(q);
        const array = snapshot.docs.map(element => ({...element.data(), firestoreid: element.id}));
        return array;
    } catch (err) {throw err;}
};

export const CLOUDFILTER = async (list, key, value) => {
    const functions = getFunctions(app, "us-central1");
    const filter = httpsCallable(functions, "filter");
    const result = await filter({ list, key, value });
    return result.data
};


export const CREATE = (reference, data) => {
  return new Promise((resolve, reject) => {
    addDoc(refList[`${reference}REF`], data)
      .then((response) => {resolve('Elmentve')})
      .catch(err => { reject(err.message)})
  })
  
};

export const CLOUDCREATE = async (reference, data) => {
  const functions = getFunctions(app, "us-central1");
  const createDocumentCall = httpsCallable(functions, "createDocument");
    try {
        const response = await createDocumentCall({reference, data});
        return response.data;
    } catch (error) {
        console.error("CREATE hiba:", error.code, error.message);
        throw new Error(error.message);
    }
};

export const UPDATE = (reference, firestoreid, data) => {
  let docRef = doc(refList[`${reference}REF`], firestoreid)
  return new Promise((resolve, reject) => {
    updateDoc(docRef, data)
      .then((response) => { resolve('Módosítás elmentve')  })
      .catch(err => {reject(err.message)})
  })
};

export const CLOUDUPDATE = async (reference, id, data) => {
  const functions = getFunctions(app, "us-central1");
  const updateDocumentCall = httpsCallable(functions, "updateDocument");
       try {
        const response = await updateDocumentCall({reference, id, data});
        return response.data.message;
    } catch (error) {
        console.error("UPDATE hiba:", error.code, error.message);
        throw new Error(error.message);
    }
};

export const uploadJson = (reference, data) => {
  return data.reduce((promise, element) => {
    return promise.then(() => {return CREATE(reference, element);});
  }, Promise.resolve());
};

export const isEmailAllowed = async (email) => {
    const functions = getFunctions(app, "us-central1");
    const checkUserEmail = httpsCallable(functions, "checkUserEmail");
    const result = await checkUserEmail({ email });
    return result.data.allowed;
}
